module.exports = __webpack_public_path__ + "static/media/Denny_19.3418b07e.png";